module.exports = __webpack_public_path__ + "static/img/13b.711d456.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/13b.jpg
// module id = cMiy
// module chunks = 0